import { EnginePagination } from '../../domain/model/engine_pagination';
import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface FetchEngineRepository {
    (pagination: Pagination): Promise<EnginePagination>
}

const fetchEngineRepository = (axios: AxiosInstance): FetchEngineRepository => async (pagination: Pagination) => {
    try {
        const response: AxiosResponse = await axios.get('/engine', {
            params: pagination
        })

        const enginePagination: EnginePagination = response.data
        return enginePagination
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchEngineRepository